import React, { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import Button from "./common/Button";
import "../styles/components/UploadTests.css";
import { toast } from "react-toastify";

export const UploadTests = () => {
  //const { userData } = useContext(UserContext);
  const [userData, setUserData] = useState({
    name: "Student",
    mathLevel: "Proficient",
    completedChallenges: 7,
    currentStreak: 3,
    totalXP: 320,
    currentRank: "Math Explorer",
    mathSkills: {
      linearEquations: { total: 12, mastered: 8 },
      quadraticEquations: { total: 9, mastered: 3 },
      functionsAndGraphs: { total: 15, mastered: 15 },
    },
    recentTests: [
      {
        id: 1,
        name: "Algebra Mid-Term Test",
        uploadedDays: 2,
        score: 42,
        total: 50,
        grade: "A-",
        strengths: ["Strong in factoring expressions"],
        improvements: ["Practice needed in solving word problems"],
      },
      {
        id: 2,
        name: "Coordinate Geometry Quiz",
        uploadedDays: 7,
        score: 18,
        total: 20,
        grade: "A+",
        strengths: [
          "Excellent at plotting points and lines",
          "Good understanding of distance formula",
        ],
        improvements: [],
      },
    ],
  });
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    // Trigger the hidden file input when the button is clicked
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Handle the file upload logic here
      console.log("File selected:", file.name);
      // You would typically send this file to a server

      // For demonstration purposes, show an alert
      toast.info(
        `File "${file.name}" selected. In a real app, this would be uploaded to the server.`,
      );

      // Reset the file input to allow selecting the same file again
      event.target.value = "";
    }
  };

  const handleDropAreaClick = () => {
    // Reuse the same file input for both buttons
    fileInputRef.current.click();
  };

  return (
    <div className="upload-tests">
      <div className="section-header">
        <div className="icon-container">
          <span className="material-icon">📄</span>
        </div>
        <h2>Upload Your Test Papers</h2>
      </div>

      <p className="instruction-text">
        Let Aanya analyze your teacher-marked tests to understand your progress.
        Simply take a photo or scan of your test paper and upload it here. Aanya
        will identify your strengths and areas for improvement.
      </p>

      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
        accept=".pdf,.jpg,.jpeg,.png"
      />

      <div className="upload-area">
        <div className="upload-box" onClick={handleDropAreaClick}>
          <div className="document-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <line x1="10" y1="9" x2="8" y2="9"></line>
            </svg>
          </div>
          <p className="upload-label">Drop your marked test here</p>
          <p className="upload-sublabel">
            Take a photo or scan your teacher-marked tests
          </p>
          <p className="upload-format">Supports PDF, JPG, or PNG formats</p>
        </div>
      </div>

      <div className="recent-tests-header">
        <h3>Recently Uploaded Tests</h3>
      </div>

      <div className="tests-list">
        {userData.recentTests.map((test) => (
          <div key={test.id} className="test-item">
            <div className="test-details">
              <h4>{test.name}</h4>
              <p className="upload-date">
                Uploaded {test.uploadedDays}{" "}
                {test.uploadedDays === 1 ? "day" : "days"} ago
              </p>
              <p className="test-score">
                Score: {test.score}/{test.total}
              </p>

              <div className="test-analysis">
                {test.strengths.map((strength, index) => (
                  <div key={index} className="analysis-item strength">
                    <span className="check-icon">✓</span> {strength}
                  </div>
                ))}

                {test.improvements.map((improvement, index) => (
                  <div key={index} className="analysis-item improvement">
                    <span className="alert-icon">⚠</span> {improvement}
                  </div>
                ))}
              </div>
            </div>
            <div className="test-grade">
              <span className="grade-label">Grade:</span>{" "}
              <span className="grade-value">{test.grade}</span>
            </div>
          </div>
        ))}
      </div>

      <Button variant="primary" fullWidth onClick={handleUploadClick}>
        Upload New Test Paper
      </Button>
      <div className="action-buttons-row">
        <Button variant="secondary" onClick={() => navigate("/")}>
          Back to Adventure Path
        </Button>
        <Button variant="primary" onClick={() => navigate("/math-challenges")}>
          Go to Challenges
        </Button>
      </div>
    </div>
  );
};

export default UploadTests;
